import GvAvatarCustom from "../GvAvatarCustom/GvAvatarCustom";
import React from "react";

export interface IPetDetail {
    id?: string
    name: string
    image?: string
    customName?: string
  }

  interface IPetAvatars {
    petDetails: IPetDetail[];
    className?: string
    height?: number;
    width?: number;
    maxVisible?: number;
}

export const capPetDetails = (petDetails: IPetDetail[], maxVisible: number): IPetDetail[] => {
  if (petDetails.length <= maxVisible) return petDetails;

  return [
    ...petDetails.slice(0, maxVisible),
    { name: "", customName: `+${petDetails.length - maxVisible}` },
  ];
};

const PetAvatars = ({ petDetails, className, height=108, width=108, maxVisible }: IPetAvatars) => {
  const visiblePets = maxVisible ? capPetDetails(petDetails, maxVisible) : petDetails;

  return (
    <div className={`flex max-w-full ${className}`} >
      {visiblePets.map((petDetail: IPetDetail, index: number) => (
        <div key={index} className={`
        rounded-full -ml-4 ${index === 0 ? "ml-0" : ""}`} style={{ zIndex: visiblePets.length - index }}>
          <GvAvatarCustom
            image={petDetail.image}
            name={petDetail.name}
            customName={petDetail.customName}
            width={width}
            height={height}
            className="border-2 border-white rounded-full"
          />
        </div>
      ))}
    </div>
  );
};

export default PetAvatars;
